module.exports = __webpack_public_path__ + "media/images/riders/small/MARCO_AURELIO_FONTANA-0fbd482470d5f769d8cb530ac5e20a18.png";